import styles from "src/assets/styles/payRedirect/pay-redirect.module.scss";
import bgImage from "src/assets/static/images/pay-bg.png";
import bgImageMobile from "src/assets/static/images/pay-bg-mobile.png";
import CurrentDeviceSize from "src/hooks/utils/currentDeviceSize";
import { Link } from "react-router-dom";
import useFormatById from "src/hooks/utils/useFormatById";
import { useSelector } from "react-redux";
import { CLIENT_SAERTO, CLIENT_UNO_ACTIVE } from "../layout";

function PayRedirect() {
  const lang = useSelector((state) => state.common.lang);
  const deviceSize = CurrentDeviceSize();
  const isMobile = deviceSize === "Mobile";
  const backgroundImage = isMobile ? bgImageMobile : bgImage;
  const f = useFormatById();

  return (
    <div
      className="pay-bg-wrapper"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        padding: "0 20px",
      }}
    >
      <div className={styles.card}>
        <h3>{f("payredirect.payment")}</h3>

        <div className={styles.links}>
          <Link
            className={styles.uno}
            to={"/" + CLIENT_UNO_ACTIVE + "/pay/" + lang}
          >
            {f("payredirect.unoAcitve")}
          </Link>

          <Link to={"/" + CLIENT_SAERTO + "/paypage/" + lang}>
            {f("payredirect.saerto")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PayRedirect;
